import { render, staticRenderFns } from "./ButtonSearch.vue?vue&type=template&id=cff848e4&scoped=true"
import script from "./ButtonSearch.vue?vue&type=script&lang=js"
export * from "./ButtonSearch.vue?vue&type=script&lang=js"
import style0 from "./ButtonSearch.vue?vue&type=style&index=0&id=cff848e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff848e4",
  null
  
)

export default component.exports